import ReactDOM from "react-dom/client";
import "./index.css";
import "./assets/styles/customBackgrounds.css";
import "./assets/styles/fonts.css";
import "./assets/styles/animationsSetting.css";
import "./assets/styles/animateStyles.css";
import "./assets/styles/stylesets.css";
import "./assets/styles/hookset.css";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
